import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

function PageHelmet({ intl }) {
  return (
    <Helmet
      title={intl.formatMessage({ id: 'helmet.title' })}
      meta={[
        { name: 'description', content: intl.formatMessage({ id: 'helmet.description' }) },
        { name: 'keywords', content: intl.formatMessage({ id: 'helmet.keywords' }) },
      ]}
    />
  );
}

export default injectIntl(PageHelmet);



// WEBPACK FOOTER //
// ./src/components/PageHelmet.js